import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import MonthEndPerfRow from './MonthEndPerfRow'
import './PerformanceTable.css'
import i18n from '../../../i18n'

class MonthEndPerfTable extends Component {
  // create the rows
  renderRows() {
    const { data, wtRegion } = this.props

    return data.map(fund => {
      return <MonthEndPerfRow key={fund.externalID} fund={fund} wtRegion={wtRegion} />
    })
  }

  // create the header
  renderHeader() {
    const { wtRegion } = this.props

    const asOfDate = this.props.data[0].stdPerformanceMonthly && this.props.data[0].stdPerformanceMonthly[0].asOfDate ? new Date(this.props.data[0].stdPerformanceMonthly[0].asOfDate).toLocaleDateString() : new Date().toLocaleDateString()

    const commonStartDate = new Date(this.props.data[0].stdPerformanceMonthly[0].commonPeriodNAVStart).toLocaleDateString()
    const commonEndDate = new Date(this.props.data[0].stdPerformanceMonthly[0].commonPeriodNAVEnd).toLocaleDateString()
    return (
      <thead>
        <tr>
          <th colSpan='3' className='textLeft'>
            MONTH END PERFORMANCE
            <br />
            {i18n.t('as of')} {asOfDate}
          </th>
          {wtRegion === 'US' && (
            <Fragment>
              <th colSpan='3' className='borderleft borderbottom textCenter'>
                {i18n.t('Month End Returns')}
              </th>
            </Fragment>
          )}
          <th colSpan='6' className='borderleft borderbottom textCenter'>
            {i18n.t('Average Annual Total Returns')}
          </th>
        </tr>
        <tr>
          <th scope='col' className='textLeft'>
            {i18n.t('Ticker')}
          </th>
          <th scope='col' className='textLeft'>
            {i18n.t('Fund')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Inception')}
            <br /> {i18n.t('Date')}
          </th>
          {wtRegion === 'US' && (
            <Fragment>
              <th scope='col' className='borderleft textCenter'>
                {i18n.t('1-Month')}
              </th>
              <th scope='col' className='textCenter'>
                {i18n.t('3-Month')}
              </th>
              <th scope='col' className='textCenter'>
                {i18n.t('YTD')}
              </th>
            </Fragment>
          )}
          <th scope='col' className='borderleft textCenter'>
            {i18n.t('1-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('3-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('5-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('10-Year')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Since')} <br />
            {i18n.t('Inception')}
          </th>
          <th scope='col' className='textCenter'>
            {i18n.t('Common Period')}
            <br /> {commonStartDate} - {commonEndDate}{' '}
          </th>
        </tr>
      </thead>
    )
  }

  render() {
    const { data } = this.props
    
    const hasPerformanceData = !data.every(x => x?.stdPerformanceMonthly && x?.stdPerformanceMonthly[0]?.mtdNAV === null);

    // Check if data, stdPerformanceMonthly, and its first item exist and are not null
    if (!data || !data[0] || !data[0].stdPerformanceMonthly || !data[0].stdPerformanceMonthly[0]) {
      return null // or return a loading indicator, or some placeholder content
    }

    // An additional check. If in the case all tickers has stdPerformanceMonthly files has null, return null
    // An example use case in a COD model (or new fund) which has no Monthly performance and the user runs it
    if (!hasPerformanceData){
      return null
    }

    return (
      <div>
        {/* <div className={s.heading}>{i18n.t('Month End Performance')}</div> */}
        <div className='table-responsive'>
          <table className='table tableFC'>
            {this.renderHeader()}
            <tbody>{this.renderRows()}</tbody>
          </table>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    wtRegion: state.params.wtRegion
  }
}

export default connect(mapStateToProps, {})(MonthEndPerfTable)
